<app-header-style-one></app-header-style-one>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Ana sayfa</a></li>
                <li>Hakkımızda</li>
            </ul>
            <h2>Hakkımızda</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="../../../../assets/story/logo/2.jpg" class="shadow" alt="image">
                    <img style="background:#fff; width:53%;" src="../../../../assets/story/logo/logo-bg.png"
                        class="shadow bottom-image" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span class="sub-title">Biz Kimiz?</span>
                    <h2>Hikayenizi Dijitale Taşıyoruz</h2>
                    <!-- <h6>Story Media Digital olarak dijital dünyada iz bırakmak isteyen markaların yol arkadaşlığını üstleniyoruz. Yaratıcılığı teknolojiyle buluşturuyor, her markanın kendi hikayesini dijital evrende en etkili şekilde anlatmasını sağlıyoruz.

                        Sosyal medya yönetiminden dijital reklam kampanyalarına, içerik üretiminden web ve mobil uygulama çözümlerine kadar uçtan uca hizmet sunuyoruz. Her projede amacımız sadece görünür olmak değil; etki yaratmak, fark oluşturmak ve hedef kitleyle gerçek bağlar kurmaktır.
                        
                        Genç, dinamik ve vizyoner ekibimizle, dijital dönüşüm yolculuğunuzda size özel stratejilerle yanınızdayız. Çünkü biz, sadece dijital işler yapmıyoruz—hikâyenizi dijitalde yaşatıyoruz.</h6> -->
                    <p>Story Media Digital olarak dijital dünyada iz bırakmak isteyen markaların yol arkadaşlığını
                        üstleniyoruz. Yaratıcılığı teknolojiyle buluşturuyor, her markanın kendi hikayesini dijital
                        evrende en etkili şekilde anlatmasını sağlıyoruz.</p>

                    <p>Sosyal medya yönetiminden dijital reklam kampanyalarına, içerik üretiminden web ve mobil
                        uygulama çözümlerine kadar uçtan uca hizmet sunuyoruz. Her projede amacımız sadece görünür olmak
                        değil; etki yaratmak, fark oluşturmak ve hedef kitleyle gerçek bağlar kurmaktır.</p>

                    <p> Genç, dinamik ve vizyoner ekibimizle, dijital dönüşüm yolculuğunuzda size özel stratejilerle
                        yanınızdayız. Çünkü biz, sadece dijital işler yapmıyoruz—hikâyenizi dijitalde yaşatıyoruz.</p>
                    <!-- <div class="features-text">
                        <h5><i class='bx bx-planet'></i>A place where you can achieve</h5>
                        <p>Education encompasses both the teaching and learning of knowledge, proper conduct, and
                            technical competency.</p>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- <div class="about-inner-area">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>100,000 online courses</h3>
                        <p>Real innovations and a positive customer experience are the heart of successful communication.</p>
                        <ul class="features-list">
                            <li><i class='bx bx-check'></i> Activate Listening</li>
                            <li><i class='bx bx-check'></i> Brilliant minds</li>
                            <li><i class='bx bx-check'></i> Better. Best. Wow!</li>
                            <li><i class='bx bx-check'></i> Branding it better!</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Expert instruction</h3>
                        <p>Real innovations and a positive customer experience are the heart of successful communication.</p>
                        <ul class="features-list">
                            <li><i class='bx bx-check'></i> Creating. Results.</li>
                            <li><i class='bx bx-check'></i> Expect more</li>
                            <li><i class='bx bx-check'></i> Good thinking</li>
                            <li><i class='bx bx-check'></i> In real we trust</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                    <div class="about-text">
                        <h3>Lifetime access</h3>
                        <p>Real innovations and a positive customer experience are the heart of successful communication.</p>
                        <ul class="features-list">
                            <li><i class='bx bx-check'></i> Stay real. Always.</li>
                            <li><i class='bx bx-check'></i> We have you covered</li>
                            <li><i class='bx bx-check'></i> We turn heads</li>
                            <li><i class='bx bx-check'></i> Your brand, promoted</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>
<!-- 
<app-our-mission></app-our-mission>

<div class="story-area ptb-100">
    <app-our-story></app-our-story>
</div>

<div class="funfacts-area">
    <div class="container">
        <div class="funfacts-inner">
            <app-funfacts></app-funfacts>
        </div>
    </div>
</div>

<div class="values-area ptb-100">
    <app-our-values></app-our-values>
</div>

<div class="instructor-area pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Make Connections</span>
            <h2>Team of Instructors</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut nisi ut aliquip ex ea.</p>
        </div>
        <app-instructors-style-two></app-instructors-style-two>
    </div>
</div>

<div class="partner-area bg-color ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Our Company & Partners</h2>
        </div>
        <app-partner-style-one></app-partner-style-one>
    </div>
</div>

<div class="testimonials-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Testimonials</span>
            <h2>What Students Says</h2>
        </div>
        <app-feedback-style-two></app-feedback-style-two>
    </div>
</div>

<app-become-instructor-partner></app-become-instructor-partner> -->